export default {
  vat55: 'TVA à 5.5%',
  vat200: 'TVA à 20%',
  bestSeller: "Ce jeu fait parti des meilleures ventes tribuo !",
  like: "Ajouter à mes coups de coeur ",
  unlike: "Retirer de mes coups de ",
}
